import { classNames } from './index';

/**
 * Maps column layout configuration to Tailwind CSS grid column span classes.
 * Supports responsive layouts for mobile, tablet, and desktop breakpoints.
 *
 * @example
 * getColSpanClass({ mobile: { cols: 12 }, tablet: { cols: 6 }, desktop: { cols: 4 } })
 * // Returns: 'col-span-12 md:col-span-6 lg:col-span-4'
 *
 * @return Combined Tailwind CSS class string
 */
export const getColSpanClass = (layout?: {
  mobile?: { cols?: number };
  tablet?: { cols?: number };
  desktop?: { cols?: number };
}): string => {
  const classes: string[] = [];

  // Mobile (default: 12)
  switch (layout?.mobile?.cols) {
    case 1:
      classes.push('col-span-1');
      break;
    case 2:
      classes.push('col-span-2');
      break;
    case 3:
      classes.push('col-span-3');
      break;
    case 4:
      classes.push('col-span-4');
      break;
    case 5:
      classes.push('col-span-5');
      break;
    case 6:
      classes.push('col-span-6');
      break;
    case 7:
      classes.push('col-span-7');
      break;
    case 8:
      classes.push('col-span-8');
      break;
    case 9:
      classes.push('col-span-9');
      break;
    case 10:
      classes.push('col-span-10');
      break;
    case 11:
      classes.push('col-span-11');
      break;
    case 12:
      classes.push('col-span-12');
      break;
    default:
      classes.push('col-span-12');
  }

  // Tablet (default: 3)
  switch (layout?.tablet?.cols) {
    case 1:
      classes.push('md:col-span-1');
      break;
    case 2:
      classes.push('md:col-span-2');
      break;
    case 3:
      classes.push('md:col-span-3');
      break;
    case 4:
      classes.push('md:col-span-4');
      break;
    case 5:
      classes.push('md:col-span-5');
      break;
    case 6:
      classes.push('md:col-span-6');
      break;
    case 7:
      classes.push('md:col-span-7');
      break;
    case 8:
      classes.push('md:col-span-8');
      break;
    case 9:
      classes.push('md:col-span-9');
      break;
    case 10:
      classes.push('md:col-span-10');
      break;
    case 11:
      classes.push('md:col-span-11');
      break;
    case 12:
      classes.push('md:col-span-12');
      break;
    default:
      classes.push('md:col-span-3');
  }

  // Desktop (default: 3)
  switch (layout?.desktop?.cols) {
    case 1:
      classes.push('lg:col-span-1');
      break;
    case 2:
      classes.push('lg:col-span-2');
      break;
    case 3:
      classes.push('lg:col-span-3');
      break;
    case 4:
      classes.push('lg:col-span-4');
      break;
    case 5:
      classes.push('lg:col-span-5');
      break;
    case 6:
      classes.push('lg:col-span-6');
      break;
    case 7:
      classes.push('lg:col-span-7');
      break;
    case 8:
      classes.push('lg:col-span-8');
      break;
    case 9:
      classes.push('lg:col-span-9');
      break;
    case 10:
      classes.push('lg:col-span-10');
      break;
    case 11:
      classes.push('lg:col-span-11');
      break;
    case 12:
      classes.push('lg:col-span-12');
      break;
    default:
      classes.push('lg:col-span-3');
  }

  return classNames(classes);
};
